/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('CacheResetIndexController', [
        '$scope',
        '$window',
        '$timeout',    
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.resetType = 'type_full_cache';
            $scope.fileName = '/assets/script.js';
            $scope.site_ids = '';
            
            $scope.resetNow = function() {
                if ($scope.resetType === 'type_file_name' && !$scope.fileName) {
                    $.alert('error', 'Empty Path/Filename', true);
                    return;
                }                                                 
                
                $scope.site_ids = $window.getSelectedSites();
                
                showModalDialog('Please confirm that the cache reset request is intended (can not be undone)', function() {
                    $('#loader').parent().show();
                    $('#loader').show();
                    
                    seApi.save("cacheReset", {resetType: $scope.resetType, fileName: $scope.fileName, site_ids: $scope.site_ids}).then(
                        function(data) {
                            $window.location.href = '/#!/se/cacheReset';
                            $.alert('success', 'message' in data ? data.message : 'Cache successfully reset', true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        },
                        function(data) {
                            $window.location.href = '/#!/se/cacheReset';
                            let error = 'message' in data ? ': '+data.message : '';
                            $.alert('error', 'Error occured'+error, true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        }
                    );
                });                 
            };
        },
    ]);
})(window.angular);
